import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment-timezone";
import { ButtonGroup, Button } from "react-bootstrap";

import "../../../css/footer.scss";
import { isAftxDomain } from "../util/AftxUtilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faCircleInfo, faCopyright } from "@fortawesome/free-solid-svg-icons";

class Footer extends Component {
  render() {
    return (
        <footer className="footer mt-auto py-2 fixed-bottom">
            <div className="container-fluid text-center">
                <div className="row">
                    <div className="col-md-12">
                        {!isAftxDomain() && (
                            <ButtonGroup aria-label="Useful Links" size="sm">
                                <Button size="sm" variant="outline-secondary" target="_blank" href={`http://tiny/submit/url?name=${encodeURIComponent(window.location.href)}`}>
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> TinyURL
                                </Button>
                                <Button size="sm" variant="outline-secondary" target="_blank" href="https://tiny.amazon.com/w3oglav9/starwwopamazdevboarbrow" rel="noopener noreferrer">
                                    User Guide <FontAwesomeIcon icon={faCircleInfo} />
                                </Button>
                            </ButtonGroup>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <FontAwesomeIcon icon={faCopyright} />&nbsp;{moment().year()} Amazon Internal
                    </div>
                </div>
            </div>
        </footer>);
    }
}

export default withRouter(Footer);
